var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_10314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.4282H25.5235V26.3007H18.5V27.4282ZM18.5 23.4349H25.5V22.3074H18.5V23.4349ZM17.0201 30.9517C16.4449 30.9517 15.9645 30.7588 15.5788 30.3729C15.1929 29.9872 15 29.5068 15 28.9316V15.1195C15 14.5445 15.1929 14.064 15.5788 13.6782C15.9645 13.2923 16.4449 13.0994 17.0201 13.0994H24.2081L29 17.8678V28.9316C29 29.5068 28.8071 29.9872 28.4212 30.3729C28.0353 30.7588 27.5549 30.9517 26.9799 30.9517H17.0201ZM23.5973 18.502V14.3678H17.0201C16.8322 14.3678 16.66 14.4461 16.5034 14.6027C16.3468 14.7593 16.2685 14.9316 16.2685 15.1195V28.9316C16.2685 29.1195 16.3468 29.2918 16.5034 29.4484C16.66 29.605 16.8322 29.6833 17.0201 29.6833H26.9799C27.1678 29.6833 27.34 29.605 27.4966 29.4484C27.6532 29.2918 27.7315 29.1195 27.7315 28.9316V18.502H23.5973Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_10314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13.0256)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.f09e87421e3bef7cbaa10c052dbaba39.svg";
export { ForwardRef as ReactComponent };